import { GETTER_INS_USER_INFO_BY_ID } from "./../constants/types";
import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import * as status from "@/store/constants/status";
import dialogTopContent from "@/components/dialog/topPicContent/topPicContent";
import { getNowTimeStamp, diffTimeStamp } from "@/utils/lodash";
import * as statusConst from "@/store/constants/status";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { isIos } from "@/utils/lodash";
import { serviceUnavailable } from "@/store/actions/gxUserInfoAction";
import EventBus from "@/utils/eventBus";
import CountDownManager from "@/views/earnCoins/earnCoin/EarnCoinCountDown";
import { remoteImg } from "@/plugins/resPlugin";

const actions: ActionTree<any, any> = {
  async [types.UPDATE_USER_STATUS]({ state, commit, dispatch, rootState }, payLoad) {
    try {
      if (payLoad.status === status.TIME_LIMIT) {
        //如果是限时的状态更新，需要新增时间戳
        // const newStatus = {
        //   userId: payLoad.userId,
        //   status: payLoad.status,
        //   limitTimeStamp: getNowTimeStamp()
        // };
        // commit(types.UPDATE_USER_STATUS, newStatus);
      }
    } catch (error) {
      return error;
    }
  },
  async [types.EARN_COINS_CHECK]({ state, commit, dispatch, rootState, getters }, payload: any) {
    try {
      //检查用户是否登陆过账号：
      if (!GeneralUtilsHelper.isLoginUser()) {
        //直接跳转到login界面：
        EventBus.$emit("toast-show", {
          type: "warning",
          content: "Log in to Instagram first to earn coins",
          duration: 2000
        });
        dispatch(types.ROUTER_PUSH, {
          name: "Login",
          params: {
            routerTransition: "up"
          }
        });
        return false;
      }

      //判断用户是否是黑客 或者账号被banned:
      console.log("断用户是否是黑客被banned:", serviceUnavailable);
      if (serviceUnavailable) {
        dispatch(types.DIALOG_SHOW, {
          title: "Service Unavailable",
          topIcon: remoteImg("/dialog/picEarncoinsServiceunavailable@3x.png"),
          midContent: `There may be something wrong with your operation, please contact us if you have any questions.`,
          buttons: [
            {
              text: "CONTACT US",
              clickFn: () => {
                GeneralUtilsHelper.clickContact();
              }
            },
            {
              text: "CANCEL",
              clickFn: () => {}
            }
          ],
          cancelFn: () => {}
        });

        return false;
      }

      //如果可用的账户为0:
      if (getters[types.GETTER_EARN_COIN_USER_LIST]("working").length === 0) {
        console.log("如果可用的账户为0:");
        //从restricted用户组中，取出能够解的：
        //1.login required 2.compelte profile

        const restrictedUserList = getters[types.GETTER_EARN_COIN_USER_LIST]("restricted");

        const findUser = restrictedUserList.find((user: any) => {
          return user.restrictedType === statusConst.LOGIN_REQUIRED || user.restrictedType === statusConst.COMPLETE_PROFILE;
        });

        console.log("找到可以解的用户：", findUser);
        if (findUser) {
          if (findUser.restrictedType === statusConst.LOGIN_REQUIRED) {
            dispatch(types.DIALOG_SHOW, {
              title: "Login Required",
              topContent: dialogTopContent(findUser.userPic, "loginRequired"),
              midContent: `Dear @${findUser.userName}, your account has expired, please login again.`,
              buttons: [
                {
                  text: "I AGREE",
                  clickFn: () => {
                    dispatch(types.ROUTER_PUSH, {
                      name: "Login",
                      params: {
                        routerTransition: "up"
                      }
                    });
                  }
                }
              ],
              cancelFn: () => {}
            });
            return false;
          }
          if (findUser.restrictedType === statusConst.COMPLETE_PROFILE) {
            const userInfo = "Dear @" + findUser.userName + ",";
            const extra = " before you could earn more coins!";
            const content = findUser.hasNoProfilePic
              ? findUser.hasNoProfileMedia
                ? "please set your profile photo and post your first photo"
                : "please set your profile photo"
              : "please post your first photo";
            dispatch(types.DIALOG_SHOW, {
              title: "Profile Info Incomplete",
              topContent: dialogTopContent(findUser.userPic, "profile"),
              midContent: userInfo + content + extra,
              buttons: [
                {
                  text: "I AGREE",
                  clickFn: () => {
                    dispatch(types.ROUTER_PUSH, {
                      // name: "Settings",
                      name: "CompleteProfile",
                      params: {
                        routerTransition: "up",
                        ...findUser
                      }
                    });
                  }
                }
              ],
              cancelFn: () => {}
            });
          }
        }
        return false;
      }

      return true;
    } catch (error) {
      console.log("EARN_COINS_CHECK error:", error);
      return false;
    }
  },
  async [types.ACCOUNT_LIMIT_CHECK]({ state, commit, dispatch, rootState, getters }, payload: any) {
    try {
      //检查用户是否登陆：

      const { feed, user } = payload;
      const { userStatusList } = state;
      const findUser: any = userStatusList.find((userStatus: any) => {
        return userStatus.userId === user.userId;
      });

      console.log("ACCOUNT_LIMIT_CHECK findUser:", findUser);

      if (!findUser) {
        return Promise.reject("findUser error");
      }
      //如果是老用户，字段的缺失问题：
      if (!findUser.hasOwnProperty("hitCount")) {
        findUser.hitCount = {
          follow: {
            count: 0,
            hitStartTimeStamp: null
          },
          like: {
            count: 0,
            hitStartTimeStamp: null
          },
          comment: {
            count: 0,
            hitStartTimeStamp: null
          }
        };
        findUser.limitedEndTimeStamp = null;
      }

      //判断用户是否login required :
      const findUserStatus = getters[types.GETTER_USER_STATUS_BY_ID](findUser.userId);
      if (findUserStatus && findUserStatus.insStatus && findUserStatus.insStatus === statusConst.LOGIN_REQUIRED) {
        const findUserInfo = getters[types.GETTER_INS_USER_INFO_BY_ID](findUser.userId);
        dispatch(types.DIALOG_SHOW, {
          title: "Login Required",
          topContent: dialogTopContent(findUserInfo.userPic, "loginRequired"),
          midContent: `Dear @${findUserInfo.userName}, your account has expired, please login again.`,
          buttons: [
            {
              text: "I AGREE",
              clickFn: () => {
                dispatch(types.ROUTER_PUSH, {
                  name: "Login",
                  params: {
                    routerTransition: "up"
                  }
                });
              }
            }
          ],
          cancelFn: () => {}
        });

        return false;
      }

      //检查用户是否缺少头像或者post
      const lackProFileOrPost = getters[types.GETTER_USER_LACK_PROFILE_OR_POST](findUser.userId);
      if (lackProFileOrPost) {
        const userInfo = "Dear @" + lackProFileOrPost.userName + ",";
        const extra = " before you could earn more coins!";
        const content = lackProFileOrPost.hasNoProfilePic
          ? lackProFileOrPost.hasNoProfileMedia
            ? "please set your profile photo and post your first photo"
            : "please set your profile photo"
          : "please post your first photo";
        dispatch(types.DIALOG_SHOW, {
          title: "Profile Info Incomplete",
          topContent: dialogTopContent(lackProFileOrPost.userPic, "profile"),
          midContent: userInfo + content + extra,
          buttons: [
            {
              text: "I AGREE",
              clickFn: () => {
                dispatch(types.ROUTER_PUSH, {
                  // name: "Settings",
                  name: "CompleteProfile",
                  params: {
                    routerTransition: "up",
                    ...lackProFileOrPost
                  }
                });
              }
            }
          ],
          cancelFn: () => {}
        });
        return false;
      }

      //首先先检查状态，如果用户处于limit状态下：
      if (findUser.status === status.TIME_LIMIT) {
        return false;
      }

      return true;
    } catch (error) {
      console.log("ACCOUNT_LIMIT_CHECK error:", error);
      return false;
    }
  },
  async [types.ACCOUNT_LIMIT_TRIGGER]({ state, commit, dispatch, rootState, getters }, payload: any) {
    try {
      //触发了用户的限制，需要更新用的信息:
      const { feed, user } = payload;
      const { userStatusList } = state;
      const findUser = userStatusList.find((userStatus: any) => {
        return userStatus.userId === user.userId;
      });
      const settingData = getters[types.GETTER_SETTING_DATA];
      let earnLimitTime = settingData.earn_limit.level_1;

      if (isIos()) {
        //IOS用宽松的限制：
        earnLimitTime = settingData.earn_limit.level_2;
      }
      const { ratelimit_slidingwindow_size, ratelimit_followerwindow_size, ratelimit_commentwindow_size } = earnLimitTime;

      const newStatus = {
        ...findUser
      };

      switch (feed.sub_kind) {
        case "follow":
          {
            newStatus.hitCount.follow.count = 0;
            newStatus.hitCount.follow.hitStartTimeStamp = new Date().valueOf();
            const diffTime = ratelimit_followerwindow_size * 1000 - (new Date().valueOf() - newStatus.hitCount.follow.hitStartTimeStamp);
            console.log("触发了follow限制，diffTime:", diffTime);
            if (diffTime > 0) {
              newStatus.status = status.TIME_LIMIT;
              newStatus.limitedEndTimeStamp = new Date().valueOf() + diffTime;
            }
          }
          break;
        case "like":
          {
            newStatus.hitCount.like.count = 0;
            newStatus.hitCount.like.hitStartTimeStamp = new Date().valueOf();
            const diffTime = ratelimit_slidingwindow_size * 1000 - (new Date().valueOf() - newStatus.hitCount.like.hitStartTimeStamp);
            console.log("触发了like限制，diffTime:", diffTime);
            if (diffTime > 0) {
              newStatus.status = status.TIME_LIMIT;
              newStatus.limitedEndTimeStamp = new Date().valueOf() + diffTime;
            }
          }
          break;
        case "comment":
          {
            newStatus.hitCount.comment.count = 0;
            newStatus.hitCount.comment.hitStartTimeStamp = new Date().valueOf();
            const diffTime = ratelimit_commentwindow_size * 1000 - (new Date().valueOf() - newStatus.hitCount.comment.hitStartTimeStamp);
            console.log("触发了commnet限制，diffTime:", diffTime);
            if (diffTime > 0) {
              newStatus.status = status.TIME_LIMIT;
              newStatus.limitedEndTimeStamp = new Date().valueOf() + diffTime;
            }
          }
          break;
        default:
          break;
      }

      commit(types.UPDATE_USER_STATUS, newStatus);

      //需要出发新的计时器：
      CountDownManager.initialCountDownManager();
    } catch (error) {
      console.log("ACCOUNT_LIMIT_TRIGGER error:", error);
    }
  },
  async [types.ACCOUNT_LIMIT_PROCESS]({ state, commit, dispatch, rootState, getters }, payload: any) {
    const { feed, user } = payload;
    const { userStatusList } = state;
    const findUser = userStatusList.find((userStatus: any) => {
      return userStatus.userId === user.userId;
    });
    const settingData = getters[types.GETTER_SETTING_DATA];
    let earnLimit = settingData.earn_limit.level_1;

    if (isIos()) {
      //IOS用宽松的限制：
      earnLimit = settingData.earn_limit.level_2;
    }

    const { window_follow_limit, window_like_limit, window_comment_limit } = earnLimit;

    if (!findUser) {
      return Promise.reject("findUser error");
    }

    switch (feed.sub_kind) {
      case "follow":
        {
          if (findUser.hitCount.follow.count === 0) {
            findUser.hitCount.follow.hitStartTimeStamp = new Date().valueOf();
          }
          findUser.hitCount.follow.count += feed.subresources.length;
          if (findUser.hitCount.follow.count >= window_follow_limit) {
            dispatch(types.ACCOUNT_LIMIT_TRIGGER, payload);
          }
        }
        break;
      case "like":
        {
          if (findUser.hitCount.like.count === 0) {
            findUser.hitCount.like.hitStartTimeStamp = new Date().valueOf();
          }
          findUser.hitCount.like.count += feed.subresources.length;
          if (findUser.hitCount.like.count >= window_like_limit) {
            dispatch(types.ACCOUNT_LIMIT_TRIGGER, payload);
          }
        }
        break;
      case "comment":
        {
          if (findUser.hitCount.comment.count === 0) {
            findUser.hitCount.comment.hitStartTimeStamp = new Date().valueOf();
          }
          findUser.hitCount.comment.count += feed.subresources.length;
          if (findUser.hitCount.comment.count >= window_comment_limit) {
            dispatch(types.ACCOUNT_LIMIT_TRIGGER, payload);
          }
        }
        break;
      default:
        break;
    }
  }
};

export default actions;
